import { useMemo } from 'react';

export const useDateTimeFormatter = () => {
  const dateFormatter = useMemo(
    () =>
      new Intl.DateTimeFormat(undefined, {
        dateStyle: 'short',
      }),
    [],
  );

  const timeFormatter = useMemo(
    () =>
      new Intl.DateTimeFormat(undefined, {
        timeStyle: 'short',
      }),
    [],
  );

  const dateTimeShortFormatter = useMemo(
    () =>
      new Intl.DateTimeFormat(undefined, {
        dateStyle: 'short',
        timeStyle: 'short',
      }),
    [],
  );

  return {
    dateFormatter,
    timeFormatter,
    dateTimeShortFormatter,
  };
};
